<div class="login-wrap d-flex align-items-center justify-content-center p-4">
  <div class="w-100 login-shell">
    <div class="login-card">
      <div class="login-brand text-center">
        <div class="brand-lockup" aria-label="TradeYourAmp">
          <span class="brand-mark">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </span>
          <div class="brand-wordmark">
            <span class="brand-dark">TradeYour</span><span class="brand-accent">Amp</span>
          </div>
        </div>
        <div class="company-name">DEMO POWER TRADING COMPANY LIMITED</div>
      </div>

      <div class="login-body">
        <h1 class="login-title">Sign in with your Account</h1>

        <form [formGroup]="form" (ngSubmit)="submit()" class="login-form">
          <div class="field-group">
            <label class="field-label">Username</label>
            <input class="form-control login-input" placeholder="Username" formControlName="username" />
          </div>

          <div class="field-group">
            <label class="field-label">Password</label>
            <div class="password-field">
              <input
                class="form-control login-input password-input"
                [type]="showPassword ? 'text' : 'password'"
                placeholder="Password"
                formControlName="password"
              />
              <button type="button" class="password-toggle" (click)="showPassword = !showPassword" aria-label="Toggle password visibility">
                <lucide-icon [img]="showPassword ? EyeOffIcon : EyeIcon" [size]="18"></lucide-icon>
              </button>
            </div>
          </div>

          <div class="field-group">
            <label class="field-label">Security Text</label>
            <div class="security-row">
              <input class="form-control login-input security-input" placeholder="Enter the shown text" formControlName="securityText" />

              <div class="security-code-box" aria-label="Security text code">
                <span class="security-noise"></span>
                <span class="security-code">{{ securityCode }}</span>
              </div>

              <button type="button" class="refresh-btn" (click)="refreshSecurityCode()" aria-label="Refresh security text">
                <lucide-icon [img]="RefreshCwIcon" [size]="18"></lucide-icon>
              </button>
            </div>
          </div>

          <button class="sign-in-btn" [disabled]="form.invalid || auth.loading()">
            {{ auth.loading() ? 'SIGNING IN...' : 'SIGN IN' }}
          </button>
        </form>

        <div class="forgot-wrap text-center">
          <button type="button" class="forgot-btn">Forgot Password?</button>
        </div>
      </div>
    </div>
  </div>
</div>
